import React from 'react'
import Select from 'react-select';
const Carrier = () => {
    const ApplicableOption = []
    return (
        <form >
            <div className="mb-3">
                <div className=" mb-1 d-flex justify-content-start gap-2 align-items-center">
                    {/* <label htmlFor="name" className="form-label mb-0 text-label-red">
                        Credit Limit
                    </label> */}
                    <div className="mb-0 form-check">
                        <input type="checkbox" className="form-check-input" id="exampleCheck1" />
                        <label className="form-label mb-0" htmlFor="exampleCheck1">
                            Air
                        </label>
                    </div>
                    <div className="mb-0 form-check">
                        <input type="checkbox" className="form-check-input" id="exampleCheck1" />
                        <label className="form-label mb-0" htmlFor="exampleCheck1">
                            Sea
                        </label>
                    </div>
                    <div className="mb-0 form-check">
                        <input type="checkbox" className="form-check-input" id="exampleCheck1" />
                        <label className="form-label mb-0" htmlFor="exampleCheck1">
                            Road
                        </label>
                    </div>
                    <div className="mb-0 form-check">
                        <input type="checkbox" className="form-check-input" id="exampleCheck1" />
                        <label className="form-label mb-0" htmlFor="exampleCheck1">
                            Rail
                        </label>
                    </div>
                </div>
                <div className="row">
                    <div className="col-md-6">
                        <label htmlFor="name" className="form-label mb-1 text-label-red">
                            AirLine
                        </label>
                        <div className="row">
                            <div className="col-3 pe-0">
                                <input
                                    type="text"
                                    className="form-control form-control-sm"
                                    id="name"
                                    name="name"
                                    placeholder='Enter Branch Name'
                                // onChange={formik.handleChange}
                                // onBlur={formik.handleBlur}
                                // value={formik.values.name}
                                />
                            </div>
                            <div className="col-9">
                                <Select

                                    className='custom-selector'
                                    options={ApplicableOption}
                                // value={ApplicableOption.find(option => option.value === formik.values.D_Format) || null} // Control the value based on Formik's state
                                // onChange={(selectedOption) => formik.setFieldValue("D_Format", selectedOption.value)} // Set the correct field in Formik
                                // onBlur={formik.handleBlur}
                                />
                            </div>
                        </div>


                    </div>
                    <div className="col-md-6">
                        <label htmlFor="name" className="form-label mb-1 text-label-red">
                            Shipping Line
                        </label>

                        <Select

                            className='custom-selector'
                            options={ApplicableOption}
                        // value={ApplicableOption.find(option => option.value === formik.values.D_Format) || null} // Control the value based on Formik's state
                        // onChange={(selectedOption) => formik.setFieldValue("D_Format", selectedOption.value)} // Set the correct field in Formik
                        // onBlur={formik.handleBlur}
                        />


                    </div>
                </div>
                {/* {formik.touched.name && formik.errors.name ? (
            <div className="error">{formik.errors.name}</div>
        ) : null} */}
            </div>
        </form>
    )
}

export default Carrier